var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#phone_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m14.864 12.34-3.327.65c-2.248-1.136-3.636-2.442-4.444-4.477l.622-3.362L6.54 2H3.509c-.911 0-1.629.759-1.492 1.666.339 2.265 1.341 6.374 4.268 9.323 3.074 3.097 7.502 4.441 9.939 4.976.941.206 1.776-.533 1.776-1.504v-2.917z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "phone_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h20v20H0z"
})))));
export default SvgPhone;